module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-left"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.change('s')
      }
    }
  }, [(_vm.size === 's') ? _c('img', {
    attrs: {
      "src": require("../../assets/images/buttons/en_font_s_on.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/images/buttons/en_font_s_off.png")
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.change('m')
      }
    }
  }, [(_vm.size === 'm') ? _c('img', {
    attrs: {
      "src": require("../../assets/images/buttons/en_font_m_on.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/images/buttons/en_font_m_off.png")
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.change('l')
      }
    }
  }, [(_vm.size === 'l') ? _c('img', {
    attrs: {
      "src": require("../../assets/images/buttons/en_font_l_on.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/images/buttons/en_font_l_off.png")
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b3bc54c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/live-player/components/modules/FontSizeSwitcher.vue
// module id = 794
// module chunks = 3